import { ReferencedProductType } from '~/Api/RoPriceReferencing/MaxPrice';
import { RoMaxPrice, Update, ValidationResult } from '~/Api/User/ProductGroup/RoMaxPrice';
import { Settings } from '~/Api/User/RoMaxPriceSettings';

export enum ActionType {
	request = 'RoMaxPrice.request',
	receive = 'RoMaxPrice.receive',
	requestUpdate = 'RoMaxPrice.requestUpdate',
	receiveUpdate = 'RoMaxPrice.receiveUpdate',
	scheduleUpdate = 'RoMaxPrice.scheduleUpdate',
	requestExport = 'RoMaxPrice.requestExport',
	receiveExport = 'RoMaxPrice.receiveExport',
	requestUserSettings = 'RoMaxPrice.requestUserSettings',
	receiveUserSettings = 'RoMaxPrice.receiveUserSettings',
	requestUserSettingsUpdate = 'RoMaxPrice.requestUserSettingsUpdate',
	receiveUserSettingsUpdate = 'RoMaxPrice.receiveUserSettingsUpdate',
	requestProductTypes = 'RoMaxPrice.requestProductTypes',
	receiveProductTypes = 'RoMaxPrice.receiveProductTypes',
	prune = 'RoMaxPrice.prune',
}

export interface RequestAction {
	groupId: string;
	request: Promise<any>;
	type: ActionType.request;
}

export interface ReceiveAction {
	groupId: string;
	roMaxPrice: RoMaxPrice | null;
	request: Promise<any>;
	type: ActionType.receive;
}

export interface ScheduleUpdateAction {
	groupId: string;
	timeoutId: NodeJS.Timeout;
	type: ActionType.scheduleUpdate;
	update: Update;
}

export interface RequestUpdateAction {
	groupId: string;
	request: Promise<any>;
	type: ActionType.requestUpdate;
}

export interface ReceiveUpdateAction {
	groupId: string;
	roMaxPrice: RoMaxPrice | null;
	request: Promise<any>;
	type: ActionType.receiveUpdate;
}

export interface RequestXlsCreateAction {
	groupId: string;
	request: Promise<any>;
	type: ActionType.requestExport;
}

export interface ReceiveXlsCreateAction {
	request: Promise<any>;
	type: ActionType.receiveExport;
	validationResult: ValidationResult | null;
}

export interface RequestUserSettingsAction {
	request: Promise<any>;
	type: ActionType.requestUserSettings;
}

export interface ReceiveUserSettingsAction {
	settings: Settings | null;
	request: Promise<any>;
	type: ActionType.receiveUserSettings;
}

export interface RequestUserSettingsUpdateAction {
	request: Promise<any>;
	type: ActionType.requestUserSettingsUpdate;
}

export interface ReceiveUserSettingsUpdateAction {
	settings: Settings | null;
	request: Promise<any>;
	type: ActionType.receiveUserSettingsUpdate;
}

export interface RequestProductTypes {
	request: Promise<any>;
	type: ActionType.requestProductTypes;
}

export interface ReceiveProductTypes {
	request: Promise<any>;
	type: ActionType.receiveProductTypes;
	types: ReferencedProductType[] | null;
}

export interface PruneAction {
	groupId: string;
	type: ActionType.prune;
}

export type Action =
	| RequestAction
	| ReceiveAction
	| ScheduleUpdateAction
	| RequestUpdateAction
	| ReceiveUpdateAction
	| RequestXlsCreateAction
	| ReceiveXlsCreateAction
	| RequestUserSettingsAction
	| ReceiveUserSettingsAction
	| RequestUserSettingsUpdateAction
	| ReceiveUserSettingsUpdateAction
	| RequestProductTypes
	| ReceiveProductTypes
	| PruneAction;
